<template>
    <div class='container'>
        <div class="content positionc">
            <div class="title">输入搜索信息</div>
            <div class="time_group">
                <div class="time_title">时间</div>
                <div class="time">
                    <div class="flc" @click="chooseStart">{{search_start}}</div>
                    <div>至</div>
                    <div class="flc" @click="chooseEnd">{{search_end}}</div>
                </div>
            </div>
            <div class="select_box">
                <div class="select_title">
                    <div>类型</div>
                </div>
                <div class="select_type">
                    <div class="select_item flc" :class="{'search_type':search_type == item.id }" v-for="(item,index) in select_type" :key="index" @click="typeClick(item.id)">
                    <!-- <div class="select_item flc" :class="{'search_type':search_type == item.id}" v-for="(item,index) in select_type" :key="index" @click="typeClick(item.id)"> -->
                        {{item.name}}
                    </div>
                </div>
            </div>
            <div class="name_box">
                <div class="title flc">姓名</div>
                    <input type="text" v-model="search_account" placeholder="请输入被邀潜客姓名">
            </div>
            <div class="btn_group">
                <div class="flc" @click="cancel">取消</div>
                <div class="flc" @click="confirm">确认</div>
            </div>
        </div>
        <van-popup v-model="BchooseTime" position="bottom">
            <van-datetime-picker @confirm="selectTime" type="date" @cancel="BchooseTime = false" title="选择年月日" :min-date="minData" :max-date="maxData" v-model="currentDate"/>
        </van-popup>
    </div>
</template>
<script>
export default {
    data(){
        return {
            select_type:[                   //注意：这个id是接口需要的
                {
                    name:'我的邀请',
                    id:'0'
                },{
                    name:'我的支持',
                    id:'1'
                },{
                    name:'我的体验间',
                    id:'2'
                },{
                    name:"全部",
                    id:'-1'
                }
            ],
            search_account:'',              //搜索姓名
            search_end:'',                  //选择开始时间
            search_start:'',                //选择结束时间
            BchooseTime:false,              //选择时间弹窗显示
            BchooseStatus:'',               //用来判断点击的是开始还是结束
            search_type:'',                 //选中的类型id
            minData:new Date(2012,0,1),     //最小的时间，因为选择开始时间后不能选择比他还小的时间，
            maxData:new Date(2032,11,31),   //最大时间，因为如果选择了结束时间后不能选择比他还大的时间
            currentDate:'',                 //设置默认选中时间
        }
    },
    created () {
        let date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        this.currentDate = new Date(year,month,day)
    },
    methods:{
        // 点击取消
        cancel () {
            this.$emit('close')
        },
        // 点击确定
        confirm () {
            let obj = {
                search_start:this.search_start?this.search_start + ' 00:00:00':this.search_start,
                search_end:this.search_end?this.search_end + ' 23:59:59':this.search_end,
                search_type:this.search_type || -1,
                search_account:this.search_account.trim()
            }
            this.$emit('confirmSearch',obj)
        },
        // 点击了类型
        typeClick (id) {
            if (this.search_type == id){
                this.search_type = ''
            } else {
                this.search_type = id
            }
            // let index = this.search_type.findIndex(i=>i==id)
            // if (index != -1) {
            //     this.search_type.splice(index,1)
            // } else {
            //     this.search_type.push(id)
            // }
        },
        // 选择时间
        selectTime (e) {
            this.BchooseTime = false;
            var time  = new Date(e);
            const year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            month = (month < 10) ? '0' + month : month
            day = (day < 10) ? '0' + day : day
            if (this.BchooseStatus == 'start') {
                this.search_start = year + '-' + month + '-' + day;
                this.minData = new Date(year,month - 1,day)
            } else {
                this.search_end = year + '-' + month + '-' + day;
                this.maxData = new Date(year,month,day)
            }
        },
        // 选择结束时间
        chooseEnd () {
            this.BchooseTime = true
            this.BchooseStatus = 'end'
            console.log('123');
            this.maxData = new Date(2032,11,31)
        },
        // 选择开始时间
        chooseStart () {
            this.BchooseTime = true
            this.BchooseStatus = 'start'
            this.minData = new Date(2012,0,1)
        }
    },
    computed: {
    }
}
</script>
<style lang='scss' scoped>
@import './index.scss';
</style>
